import React from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { patch } from '../../../services/apiController';
import AlertIcon from '../../../../src/img.svg';

const MarkShopCloseModal = (props) => {
  const { agreementId, open, onClose, callback } = props;

  const handleSubmit = (e) => {
    e.preventDefault();
    patch({ isShopClosed: true }, `/agreements/${agreementId}`)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response?.data?.message);
          onClose();
          callback();
        }
      })
      .catch((error) => {
        toast.error(error.response?.data?.data?.message || error?.response?.data?.message || error?.message || 'internal error');
      });
  };

  return (
    <Modal size="sm" show={open} backdrop="static" keyboard={false} className="request-modal">
      <Modal.Header className="bg-danger text-light py-2">
        <Modal.Title>Mark Shop as Closed</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-start">
          <img src={AlertIcon} alt="alert" />
          <p className="ps-3 mb-0">Are you sure want to mark this shop as closed? This action can't be undone.</p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="btn-wrapper">
          <button onClick={onClose} className="btn app-btn-default btn-sm">
            Cancel
          </button>
          <button onClick={handleSubmit} className="btn app-btn-danger btn-sm">
            Submit
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default MarkShopCloseModal;
